import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { initialPurchaseState, PurchaseState } from './types'

export const purchase: Module<PurchaseState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialPurchaseState),
  actions,
  getters,
  mutations,
}
